import React from "react";
import { monthListObject } from "utils/common";
import { MonthOptions, UserLevel } from "utils/constant";

export default function TableComponent({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
  laporanType,
}) {
  const levelName =
    currentLevel === UserLevel.National
      ? "Nasional"
      : currentLevel === UserLevel.Province
        ? "Provinsi"
        : currentLevel === UserLevel.District
          ? "Kabupaten/Kota"
          : "Puskesmas";

  const faskesName = (() => {
    const data = reportInfo?.fasyankes;
    const parts = data?.split(",");
    const names = parts?.map((p) => p?.split("|")[1]);
    return names?.join(", ");
  })();

  const monthNameFromYM = (val) => {
    if (!val) return "";

    const str = String(val);
    let mm = str.includes("-") ? str.split("-")[1] : str;

    if (/^\d{1,2}$/.test(mm)) mm = mm.padStart(2, "0");

    let opt = MonthOptions.find((o) => String(o.value).padStart(2, "0") === mm);
    if (opt) return opt.label;

    opt = MonthOptions.find((o) => o.label.toLowerCase() === str.toLowerCase());
    return opt ? opt.label : "";
  };

  const renderTableByLevel = () => {
    switch (currentLevel) {
      case UserLevel.Fasyankes: {
        // Filter out total row for data display, and find the total row for footer
        const dataRows = reportsData?.filter((row) => !row.is_total_row) ?? [];
        const totalRow = reportsData?.find((row) => row.is_total_row);

        return (
          <>
            <thead>
              <tr>
                <th>No.</th>
                <th>Nama Desa</th>
                {(laporanType === "Kelambu Massal Fokus" ||
                  laporanType === "Kelambu Massal Total") && (
                  <th>Jumlah Penduduk Sasaran</th>
                )}
                {(laporanType === "Kelambu PE 1-2-5" ||
                  laporanType === "Kelambu KLB/Bencana") && (
                  <>
                    <th>Jumlah Penduduk Sasaran</th>
                    <th>Jumlah Penduduk Desa</th>
                    <th>
                      Tanggal Distribusi {laporanType.replace("kelambu ", "")}
                    </th>
                  </>
                )}
                {(laporanType === "Kelambu Massal Fokus" ||
                  laporanType === "Kelambu Massal Total") && (
                  <>
                    <th>{`Jumlah Kelambu ${
                      laporanType
                        ? ` ${
                            laporanType === "Kelambu Massal Total"
                              ? "Massal"
                              : laporanType.replace("Kelambu ", "")
                          }`
                        : ""
                    }${` Hasil Desk`}`}</th>
                    <th>{`Jumlah Kelambu ${
                      laporanType
                        ? ` ${
                            laporanType === "Kelambu Massal Total"
                              ? "Massal"
                              : laporanType.replace("Kelambu ", "")
                          }`
                        : ""
                    }${` Diterima`}`}</th>
                    <th>
                      Bulan Distribusi Kelambu{" "}
                      {laporanType === "Kelambu Massal Total"
                        ? "Massal"
                        : laporanType.replace("Kelambu ", "")}
                    </th>
                  </>
                )}
                <th>{`Jumlah Kelambu ${
                  laporanType
                    ? ` ${
                        laporanType === "Kelambu Massal Total"
                          ? "Massal"
                          : laporanType.replace("Kelambu ", "")
                      }`
                    : ""
                }${` Terdistribusi`}`}</th>
                <th>Jumlah Kelambu Terdistribusi Kepada Ibu Hamil</th>
                <th>Nama Dusun</th>
                {(laporanType === "Kelambu Massal Fokus" ||
                  laporanType === "Kelambu Massal Total") && (
                  <>
                    <th>Jumlah Penduduk Dusun Sasaran</th>
                    <th>{`Jumlah Kelambu ${
                      laporanType
                        ? ` ${
                            laporanType === "Kelambu Massal Total"
                              ? "Massal"
                              : laporanType.replace("Kelambu ", "")
                          }`
                        : ""
                    }${` Terdistribusi Tingkat Dusun`}`}</th>
                  </>
                )}
                {(laporanType === "Kelambu PE 1-2-5" ||
                  laporanType === "Kelambu KLB/Bencana") && (
                  <>
                    <th>Jumlah Penduduk Dusun</th>
                    <th>{`Jumlah Kelambu Terdistribusi${
                      laporanType
                        ? ` ${
                            laporanType === "Kelambu Massal Total"
                              ? "Massal"
                              : laporanType.replace("Kelambu ", "")
                          }`
                        : ""
                    }`}</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {dataRows?.length ? (
                dataRows.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row?.no ?? idx + 1}</td>
                    <td>{row?.nama_desa ?? "-"}</td>
                    {(laporanType === "Kelambu Massal Fokus" ||
                      laporanType === "Kelambu Massal Total") && (
                      <td>{row?.jumlah_penduduk_sasaran ?? "0"}</td>
                    )}
                    {(laporanType === "Kelambu PE 1-2-5" ||
                      laporanType === "Kelambu KLB/Bencana") && (
                      <>
                        <td>{row?.jumlah_penduduk_sasaran ?? "0"}</td>
                        <td>{row?.jumlah_penduduk_desa ?? "0"}</td>
                        <td>{row?.tanggal_distribusi_kelambu ?? "-"}</td>
                      </>
                    )}
                    {(laporanType === "Kelambu Massal Fokus" ||
                      laporanType === "Kelambu Massal Total") && (
                      <>
                        <td>
                          {laporanType === "Kelambu Massal Total"
                            ? row?.jumlah_kelambu_massal_hasil_desk
                            : row?.jumlah_kelambu_fokus_hasil_desk}
                        </td>
                        <td>{row?.jumlah_kelambu_diterima ?? "0"}</td>
                        <td>
                          {monthNameFromYM(row?.bulan_distribusi_kelambu) ||
                            "-"}
                        </td>
                      </>
                    )}
                    <td>{row?.jumlah_kelambu_terdistribusi ?? "0"}</td>
                    <td>
                      {row?.jumlah_kelambu_terdistribusi_kepada_ibu_hamil ??
                        "0"}
                    </td>
                    <td>{row?.nama_dusun ?? "-"}</td>
                    <td>{row?.jumlah_penduduk_dusun_sasaran ?? "0"}</td>
                    <td>
                      {row?.jumlah_kelambu_terdistribusi_tingkat_dusun ?? "0"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={10}>Tidak Ada Data</td>
                </tr>
              )}
            </tbody>
            {dataRows?.length > 0 && totalRow && (
              <tfoot>
                <tr
                  style={{
                    fontWeight: "bold",
                    backgroundColor: "#43766C",
                  }}
                >
                  <td style={{ color: "#FFF" }} colSpan={2}>
                    Total
                  </td>
                  {(laporanType === "Kelambu Massal Fokus" ||
                    laporanType === "Kelambu Massal Total") && (
                    <td style={{ color: "#FFF" }}>
                      {totalRow?.jumlah_penduduk_sasaran ?? "0"}
                    </td>
                  )}
                  {(laporanType === "Kelambu PE 1-2-5" ||
                    laporanType === "Kelambu KLB/Bencana") && (
                    <>
                      <td style={{ color: "#FFF" }}>
                        {totalRow?.jumlah_penduduk_sasaran ?? "0"}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {totalRow?.jumlah_penduduk_desa ?? "0"}
                      </td>
                      <td style={{ color: "#FFF" }}>-</td>
                    </>
                  )}
                  {(laporanType === "Kelambu Massal Fokus" ||
                    laporanType === "Kelambu Massal Total") && (
                    <>
                      <td style={{ color: "#FFF" }}>
                        {laporanType === "Kelambu Massal Total"
                          ? (totalRow?.jumlah_kelambu_massal_hasil_desk ?? "0")
                          : (totalRow?.jumlah_kelambu_fokus_hasil_desk ?? "0")}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {totalRow?.jumlah_kelambu_diterima ?? "0"}
                      </td>
                      <td style={{ color: "#FFF" }}>-</td>
                    </>
                  )}
                  <td style={{ color: "#FFF" }}>
                    {totalRow?.jumlah_kelambu_terdistribusi ?? "0"}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {totalRow?.jumlah_kelambu_terdistribusi_kepada_ibu_hamil ??
                      "0"}
                  </td>
                  <td style={{ color: "#FFF" }}>-</td>
                  <td style={{ color: "#FFF" }}>
                    {totalRow?.jumlah_penduduk_dusun_sasaran ?? "0"}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {totalRow?.jumlah_kelambu_terdistribusi_tingkat_dusun ??
                      "0"}
                  </td>
                </tr>
              </tfoot>
            )}
          </>
        );
      }

      case UserLevel.District:
        return (
          <>
            <thead>
              <tr>
                <th>No.</th>
                <th>Nama Puskesmas</th>
                <th>Jumlah Desa</th>
                {(laporanType === "Kelambu Massal Fokus" ||
                  laporanType === "Kelambu Massal Total") && (
                  <th>Jumlah Penduduk Sasaran</th>
                )}
                {(laporanType === "Kelambu PE 1-2-5" ||
                  laporanType === "Kelambu KLB/Bencana") && (
                  <>
                    <th>Jumlah Penduduk Sasaran</th>
                    <th>Jumlah Penduduk Desa</th>
                  </>
                )}
                {(laporanType === "Kelambu Massal Total" ||
                  laporanType === "Kelambu Massal Fokus") && (
                  <>
                    <th>{`Jumlah Kelambu ${
                      laporanType
                        ? ` ${
                            laporanType === "Kelambu Massal Total"
                              ? "Massal"
                              : laporanType.replace("Kelambu ", "")
                          }`
                        : ""
                    }${` Hasil Desk`}`}</th>
                    <th>{`Jumlah Kelambu ${
                      laporanType
                        ? ` ${
                            laporanType === "Kelambu Massal Total"
                              ? "Massal"
                              : laporanType.replace("Kelambu ", "")
                          }`
                        : ""
                    }${` Diterima`}`}</th>
                  </>
                )}
                <th>{`Jumlah Kelambu ${
                  laporanType
                    ? ` ${
                        laporanType === "Kelambu Massal Total"
                          ? "Massal"
                          : laporanType.replace("Kelambu ", "")
                      }`
                    : ""
                }${` Terdistribusi`}`}</th>
                <th>Jumlah Kelambu Terdistribusi Kepada Ibu Hamil</th>
                <th>Jumlah Dusun</th>
                <th>Jumlah Kelambu Terdistribusi Tingkat Dusun</th>
                {(laporanType === "Kelambu Massal Total" ||
                  laporanType === "Kelambu Massal Fokus") && (
                  <th>
                    % Capaian Distribusi Kelambu
                    {laporanType === "Kelambu Massal Total"
                      ? " Massal"
                      : " Fokus"}
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {reportsData?.length ? (
                reportsData.map((row, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{row?.nama_fasyankes ?? "-"}</td>
                    <td>
                      {row?.daftar_kd_desa?.length ?? row?.jumlah_desa ?? 0}
                    </td>
                    {(laporanType === "Kelambu Massal Fokus" ||
                      laporanType === "Kelambu Massal Total") && (
                      <td>{row?.sum_total_penduduk_sasaran ?? 0}</td>
                    )}
                    {(laporanType === "Kelambu PE 1-2-5" ||
                      laporanType === "Kelambu KLB/Bencana") && (
                      <>
                        <td>{row?.sum_total_penduduk_sasaran ?? 0}</td>
                        <td>{row?.sum_total_pop_desa ?? 0}</td>
                      </>
                    )}
                    {(laporanType === "Kelambu Massal Total" ||
                      laporanType === "Kelambu Massal Fokus") && (
                      <>
                        <td>
                          {laporanType === "Kelambu Massal Total"
                            ? row?.sum_kelambu_massal_hasil_desk
                            : (row?.sum_kelambu_fokus_hasil_desk ?? 0)}
                        </td>
                        <td>{row?.sum_total_kelambu_diterima ?? 0}</td>
                      </>
                    )}
                    <td>{row?.sum_total_kelambu_distribusi ?? 0}</td>
                    <td>
                      {row?.sum_total_kelambu_terdistribusi_kepada_ibu_hamil ??
                        0}
                    </td>
                    <td>{row?.sum_total_dusun ?? 0}</td>
                    <td>{row?.sum_total_kelambu_distribusi_dusun ?? 0}</td>
                    {(laporanType === "Kelambu Massal Total" ||
                      laporanType === "Kelambu Massal Fokus") && (
                      <td>
                        {row?.pct_capaian_distribusi != null
                          ? `${row.pct_capaian_distribusi}%`
                          : "-"}
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={10}>Tidak Ada Data</td>
                </tr>
              )}
            </tbody>
            {reportsData?.length > 0 && (
              <tfoot>
                <tr
                  style={{
                    fontWeight: "bold",
                    backgroundColor: "#43766C",
                  }}
                >
                  <td style={{ color: "#FFF" }} colSpan={2}>
                    Total
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum +
                        (row?.daftar_kd_desa?.length ?? row?.jumlah_desa ?? 0),
                      0,
                    )}
                  </td>
                  {(laporanType === "Kelambu Massal Fokus" ||
                    laporanType === "Kelambu Massal Total") && (
                    <td style={{ color: "#FFF" }}>
                      {reportsData.reduce(
                        (sum, row) =>
                          sum +
                          (parseInt(row?.sum_total_penduduk_sasaran) || 0),
                        0,
                      )}
                    </td>
                  )}
                  {(laporanType === "Kelambu PE 1-2-5" ||
                    laporanType === "Kelambu KLB/Bencana") && (
                    <>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(row?.sum_total_penduduk_sasaran) || 0),
                          0,
                        )}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum + (parseInt(row?.sum_total_pop_desa) || 0),
                          0,
                        )}
                      </td>
                    </>
                  )}
                  {(laporanType === "Kelambu Massal Total" ||
                    laporanType === "Kelambu Massal Fokus") && (
                    <>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(
                              laporanType === "Kelambu Massal Total"
                                ? row?.sum_kelambu_massal_hasil_desk
                                : row?.sum_kelambu_fokus_hasil_desk,
                            ) || 0),
                          0,
                        )}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(row?.sum_total_kelambu_diterima) || 0),
                          0,
                        )}
                      </td>
                    </>
                  )}
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum +
                        (parseInt(row?.sum_total_kelambu_distribusi) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum +
                        (parseInt(
                          row?.sum_total_kelambu_terdistribusi_kepada_ibu_hamil,
                        ) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) => sum + (parseInt(row?.sum_total_dusun) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum +
                        (parseInt(row?.sum_total_kelambu_distribusi_dusun) ||
                          0),
                      0,
                    )}
                  </td>
                  {(laporanType === "Kelambu Massal Total" ||
                    laporanType === "Kelambu Massal Fokus") && (
                    <td style={{ color: "#FFF" }}>
                      {(() => {
                        const totalDiterima = reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(row?.sum_total_kelambu_diterima) || 0),
                          0,
                        );
                        const totalDistribusi = reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(row?.sum_total_kelambu_distribusi) || 0),
                          0,
                        );
                        return totalDiterima > 0
                          ? `${((totalDistribusi / totalDiterima) * 100).toFixed(2)}%`
                          : "-";
                      })()}
                    </td>
                  )}
                </tr>
              </tfoot>
            )}
          </>
        );

      case UserLevel.Province:
        return (
          <>
            <thead>
              <tr>
                <th>No.</th>
                <th>Nama Kabupaten/Kota</th>
                <th>Jumlah Puskesmas</th>
                {(laporanType === "Kelambu Massal Fokus" ||
                  laporanType === "Kelambu Massal Total") && (
                  <th>Jumlah Penduduk Sasaran</th>
                )}
                {(laporanType === "Kelambu PE 1-2-5" ||
                  laporanType === "Kelambu KLB/Bencana") && (
                  <>
                    <th>Jumlah Penduduk Sasaran</th>
                    <th>Jumlah Penduduk Puskesmas</th>
                  </>
                )}
                {(laporanType === "Kelambu Massal Total" ||
                  laporanType === "Kelambu Massal Fokus") && (
                  <>
                    <th>{`Jumlah Kelambu ${
                      laporanType
                        ? ` ${
                            laporanType === "Kelambu Massal Total"
                              ? "Massal"
                              : laporanType.replace("Kelambu ", "")
                          }`
                        : ""
                    }${` Hasil Desk`}`}</th>
                    <th>{`Jumlah Kelambu ${
                      laporanType
                        ? ` ${
                            laporanType === "Kelambu Massal Total"
                              ? "Massal"
                              : laporanType.replace("Kelambu ", "")
                          }`
                        : ""
                    }${` Diterima`}`}</th>
                    <th>{`Jumlah Kelambu ${
                      laporanType
                        ? ` ${
                            laporanType === "Kelambu Massal Total"
                              ? "Massal"
                              : laporanType.replace("Kelambu ", "")
                          }`
                        : ""
                    }${` Terdistribusi`}`}</th>
                    <th>Jumlah Kelambu Terdistribusi Kepada Ibu Hamil</th>
                    <th>Jumlah Desa</th>
                    <th>Jumlah Kelambu Terdistribusi Tingkat Desa</th>
                    <th>
                      % Capaian Distribusi Kelambu
                      {laporanType === "Kelambu Massal Total"
                        ? " Massal"
                        : " Fokus"}
                    </th>
                  </>
                )}
                {laporanType === "Kelambu PE 1-2-5" && (
                  <>
                    <th>Jumlah Kelambu PE 1-2-5 Terdistribusi</th>
                    <th>
                      Jumlah Kelambu PE 1-2-5 Terdistribusi Kepada Ibu Hamil
                    </th>
                    <th>Jumlah Desa</th>
                    <th>Jumlah Kelambu PE 1-2-5 Terdistribusi</th>
                  </>
                )}
                {laporanType === "Kelambu KLB/Bencana" && (
                  <>
                    <th>Jumlah Kelambu KLB/Bencana Terdistribusi</th>
                    <th>
                      Jumlah Kelambu KLB/Bencana Terdistribusi Kepada Ibu Hamil
                    </th>
                    <th>Jumlah Desa</th>
                    <th>Jumlah Kelambu KLB/Bencana Terdistribusi</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {reportsData?.length ? (
                reportsData.map((row, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{row?.nama_kabupaten ?? row?.wilayah ?? "-"}</td>
                    <td>{row?.jumlah_faskes ?? 0}</td>
                    {(laporanType === "Kelambu Massal Fokus" ||
                      laporanType === "Kelambu Massal Total") && (
                      <td>{row?.sum_total_penduduk_sasaran ?? 0}</td>
                    )}
                    {(laporanType === "Kelambu PE 1-2-5" ||
                      laporanType === "Kelambu KLB/Bencana") && (
                      <>
                        <td>{row?.sum_total_penduduk_sasaran ?? 0}</td>
                        <td>{row?.sum_total_pop_desa ?? 0}</td>
                      </>
                    )}
                    {(laporanType === "Kelambu Massal Total" ||
                      laporanType === "Kelambu Massal Fokus") && (
                      <>
                        <td>
                          {laporanType === "Kelambu Massal Total"
                            ? row?.sum_kelambu_massal_hasil_desk
                            : (row?.sum_kelambu_fokus_hasil_desk ?? 0)}
                        </td>
                        <td>{row?.sum_total_kelambu_diterima ?? 0}</td>
                        <td>{row?.sum_total_kelambu_distribusi_desa ?? 0}</td>
                        <td>
                          {row?.sum_total_kelambu_terdistribusi_kepada_ibu_hamil ??
                            0}
                        </td>
                        <td>{row?.jumlah_desa ?? 0}</td>
                        <td>{row?.sum_total_kelambu_distribusi_desa ?? 0}</td>
                        <td>{row?.persen_capaian ?? 0} %</td>
                      </>
                    )}
                    {laporanType === "Kelambu PE 1-2-5" && (
                      <>
                        <td>{row?.sum_total_kelambu_distribusi ?? 0}</td>
                        <td>
                          {row?.sum_total_kelambu_terdistribusi_kepada_ibu_hamil ??
                            0}
                        </td>
                        <td>{row?.jumlah_desa ?? 0}</td>
                        <td>{row?.sum_total_kelambu_distribusi_desa ?? 0}</td>
                      </>
                    )}
                    {laporanType === "Kelambu KLB/Bencana" && (
                      <>
                        <td>{row?.sum_total_kelambu_distribusi ?? 0}</td>
                        <td>
                          {row?.sum_total_kelambu_terdistribusi_kepada_ibu_hamil ??
                            0}
                        </td>
                        <td>{row?.jumlah_desa ?? 0}</td>
                        <td>{row?.sum_total_kelambu_distribusi_desa ?? 0}</td>
                      </>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8}>Tidak Ada Data</td>
                </tr>
              )}
            </tbody>
            {reportsData?.length > 0 && (
              <tfoot>
                <tr
                  style={{
                    fontWeight: "bold",
                    backgroundColor: "#43766C",
                  }}
                >
                  <td style={{ color: "#FFF" }} colSpan={2}>
                    Total
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) => sum + (parseInt(row?.jumlah_faskes) || 0),
                      0,
                    )}
                  </td>
                  {(laporanType === "Kelambu Massal Fokus" ||
                    laporanType === "Kelambu Massal Total") && (
                    <td style={{ color: "#FFF" }}>
                      {reportsData.reduce(
                        (sum, row) =>
                          sum +
                          (parseInt(row?.sum_total_penduduk_sasaran) || 0),
                        0,
                      )}
                    </td>
                  )}
                  {(laporanType === "Kelambu PE 1-2-5" ||
                    laporanType === "Kelambu KLB/Bencana") && (
                    <>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(row?.sum_total_penduduk_sasaran) || 0),
                          0,
                        )}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum + (parseInt(row?.sum_total_pop_desa) || 0),
                          0,
                        )}
                      </td>
                    </>
                  )}
                  {(laporanType === "Kelambu Massal Total" ||
                    laporanType === "Kelambu Massal Fokus") && (
                    <>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(
                              laporanType === "Kelambu Massal Total"
                                ? row?.sum_kelambu_massal_hasil_desk
                                : row?.sum_kelambu_fokus_hasil_desk,
                            ) || 0),
                          0,
                        )}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(row?.sum_total_kelambu_diterima) || 0),
                          0,
                        )}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(row?.sum_total_kelambu_distribusi_desa) ||
                              0),
                          0,
                        )}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(
                              row?.sum_total_kelambu_terdistribusi_kepada_ibu_hamil,
                            ) || 0),
                          0,
                        )}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) => sum + (parseInt(row?.jumlah_desa) || 0),
                          0,
                        )}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(row?.sum_total_kelambu_distribusi_desa) ||
                              0),
                          0,
                        )}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {(() => {
                          const totalDiterima = reportsData.reduce(
                            (sum, row) =>
                              sum +
                              (parseInt(row?.sum_total_kelambu_diterima) || 0),
                            0,
                          );
                          const totalDistribusi = reportsData.reduce(
                            (sum, row) =>
                              sum +
                              (parseInt(
                                row?.sum_total_kelambu_distribusi_desa,
                              ) || 0),
                            0,
                          );
                          return totalDiterima > 0
                            ? `${((totalDistribusi / totalDiterima) * 100).toFixed(2)}%`
                            : "-";
                        })()}
                      </td>
                    </>
                  )}
                  {laporanType === "Kelambu PE 1-2-5" && (
                    <>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(row?.sum_total_kelambu_distribusi) || 0),
                          0,
                        )}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(
                              row?.sum_total_kelambu_terdistribusi_kepada_ibu_hamil,
                            ) || 0),
                          0,
                        )}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) => sum + (parseInt(row?.jumlah_desa) || 0),
                          0,
                        )}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(row?.sum_total_kelambu_distribusi_desa) ||
                              0),
                          0,
                        )}
                      </td>
                    </>
                  )}
                  {laporanType === "Kelambu KLB/Bencana" && (
                    <>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(row?.sum_total_kelambu_distribusi) || 0),
                          0,
                        )}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(
                              row?.sum_total_kelambu_terdistribusi_kepada_ibu_hamil,
                            ) || 0),
                          0,
                        )}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) => sum + (parseInt(row?.jumlah_desa) || 0),
                          0,
                        )}
                      </td>
                      <td style={{ color: "#FFF" }}>
                        {reportsData.reduce(
                          (sum, row) =>
                            sum +
                            (parseInt(row?.sum_total_kelambu_distribusi_desa) ||
                              0),
                          0,
                        )}
                      </td>
                    </>
                  )}
                </tr>
              </tfoot>
            )}
          </>
        );

      default: {
        if (
          laporanType === "Kelambu PE 1-2-5" ||
          laporanType === "Kelambu KLB/Bencana"
        ) {
          // Group rows by province
          const groupedPE = {};
          reportsData?.forEach((row) => {
            const key = row.kd_provinsi;
            if (!groupedPE[key]) {
              groupedPE[key] = {
                nama_provinsi: row.nama_provinsi,
                rows: [],
              };
            }
            groupedPE[key].rows.push(row);
          });

          const displayRowsPE = [];
          Object.keys(groupedPE).forEach((provKey) => {
            const group = groupedPE[provKey];
            group.rows.forEach((row) => {
              displayRowsPE.push({ ...row, _isSubTotal: false });
            });
            const subTotal = {
              _isSubTotal: true,
              nama_provinsi: group.nama_provinsi,
              sum_total_kelambu_terdistribusi: group.rows.reduce(
                (s, r) =>
                  s + (parseInt(r.sum_total_kelambu_terdistribusi) || 0),
                0,
              ),
            };
            displayRowsPE.push(subTotal);
          });

          let rowNumberPE = 0;

          return (
            <>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Nama Provinsi</th>
                  <th>Nama Kabupaten/Kota</th>
                  {laporanType === "Kelambu PE 1-2-5" && (
                    <th>Jumlah Kelambu PE 1-2-5 Terdistribusi</th>
                  )}
                  {laporanType === "Kelambu KLB/Bencana" && (
                    <th>Jumlah Kelambu KLB/Bencana Terdistribusi</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {displayRowsPE?.length ? (
                  displayRowsPE.map((row, idx) => {
                    const isSubTotal = row._isSubTotal;
                    if (!isSubTotal) rowNumberPE++;
                    const summaryStyle = isSubTotal
                      ? {
                          fontWeight: "bold",
                          backgroundColor: "#C4D7B2",
                        }
                      : {};

                    return (
                      <tr key={idx} style={summaryStyle}>
                        <td>{isSubTotal ? "" : rowNumberPE}</td>
                        {!isSubTotal && <td>{row?.nama_provinsi ?? "-"}</td>}
                        <td colSpan={isSubTotal ? 2 : 1}>
                          {isSubTotal
                            ? `TOTAL ${row?.nama_provinsi ?? ""}`
                            : (row?.nama_kabupaten ?? "-")}
                        </td>
                        <td>{row?.sum_total_kelambu_terdistribusi ?? 0}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={4}>Tidak Ada Data</td>
                  </tr>
                )}
              </tbody>
              {reportsData?.length > 0 && (
                <tfoot>
                  <tr
                    style={{
                      fontWeight: "bold",
                      backgroundColor: "#43766C",
                    }}
                  >
                    <td style={{ color: "#FFF" }} colSpan={3}>
                      Total
                    </td>
                    <td style={{ color: "#FFF" }}>
                      {reportsData.reduce(
                        (sum, row) =>
                          sum +
                          (parseInt(row?.sum_total_kelambu_terdistribusi) || 0),
                        0,
                      )}
                    </td>
                  </tr>
                </tfoot>
              )}
            </>
          );
        }

        // For Kelambu Massal/Fokus, use detailed kabupaten-grouped format
        // Group rows by province
        const grouped = {};
        reportsData?.forEach((row) => {
          const key = row.kd_provinsi;
          if (!grouped[key]) {
            grouped[key] = {
              nama_provinsi: row.nama_provinsi,
              rows: [],
            };
          }
          grouped[key].rows.push(row);
        });

        // Build display rows: kabupaten rows + province subtotal rows
        const displayRows = [];
        Object.keys(grouped).forEach((provKey) => {
          const group = grouped[provKey];
          group.rows.forEach((row) => {
            displayRows.push({ ...row, _isSubTotal: false });
          });
          // Compute province subtotal
          const subTotal = {
            _isSubTotal: true,
            nama_provinsi: group.nama_provinsi,
            sum_kelambu_massal_hasil_desk: group.rows.reduce(
              (s, r) => s + (parseInt(r.sum_kelambu_massal_hasil_desk) || 0),
              0,
            ),
            sum_kelambu_fokus_hasil_desk: group.rows.reduce(
              (s, r) => s + (parseInt(r.sum_kelambu_fokus_hasil_desk) || 0),
              0,
            ),
            sum_total_kelambu_diterima: group.rows.reduce(
              (s, r) => s + (parseInt(r.sum_total_kelambu_diterima) || 0),
              0,
            ),
            sum_total_kelambu_distribusi_desa: group.rows.reduce(
              (s, r) =>
                s + (parseInt(r.sum_total_kelambu_distribusi_desa) || 0),
              0,
            ),
            sum_total_kelambu_terdistribusi_kepada_ibu_hamil: group.rows.reduce(
              (s, r) =>
                s +
                (parseInt(r.sum_total_kelambu_terdistribusi_kepada_ibu_hamil) ||
                  0),
              0,
            ),
            sum_total_kelambu_distribusi_faskes: group.rows.reduce(
              (s, r) =>
                s + (parseInt(r.sum_total_kelambu_distribusi_faskes) || 0),
              0,
            ),
          };
          // Compute persen_capaian for subtotal
          const totalDiterimaSubTotal =
            parseInt(subTotal.sum_total_kelambu_diterima) || 0;
          const totalDistribusiSubTotal =
            parseInt(subTotal.sum_total_kelambu_distribusi_desa) || 0;
          subTotal.persen_capaian =
            totalDiterimaSubTotal > 0
              ? (
                  (totalDistribusiSubTotal / totalDiterimaSubTotal) *
                  100
                ).toFixed(2)
              : null;
          displayRows.push(subTotal);
        });

        let rowNumber = 0;

        return (
          <>
            <thead>
              <tr>
                <th>No.</th>
                <th>Nama Provinsi</th>
                <th>Nama Kabupaten/Kota</th>
                <th>{`Jumlah Kelambu ${
                  laporanType === "Kelambu Massal Total"
                    ? "Massal"
                    : laporanType.replace("Kelambu ", "")
                } Hasil Desk`}</th>
                <th>{`Jumlah Kelambu ${
                  laporanType === "Kelambu Massal Total"
                    ? "Massal"
                    : laporanType.replace("Kelambu ", "")
                } Diterima`}</th>
                <th>{`Jumlah Kelambu ${
                  laporanType === "Kelambu Massal Total"
                    ? "Massal"
                    : laporanType.replace("Kelambu ", "")
                } Terdistribusi`}</th>
                <th>{`Jumlah Kelambu Terdistribusi Kepada Ibu Hamil`}</th>
                <th>
                  % Capaian Distribusi Kelambu
                  {laporanType === "Kelambu Massal Total"
                    ? " Massal"
                    : " Fokus"}
                </th>
              </tr>
            </thead>
            <tbody>
              {displayRows?.length ? (
                displayRows.map((row, idx) => {
                  const isSubTotal = row._isSubTotal;
                  if (!isSubTotal) rowNumber++;
                  const summaryStyle = isSubTotal
                    ? {
                        fontWeight: "bold",
                        backgroundColor: "#C4D7B2",
                      }
                    : {};

                  return (
                    <tr key={idx} style={summaryStyle}>
                      <td>{isSubTotal ? "" : rowNumber}</td>
                      {!isSubTotal && <td>{row?.nama_provinsi ?? "-"}</td>}
                      <td colSpan={isSubTotal ? 2 : 1}>
                        {isSubTotal
                          ? `TOTAL ${row?.nama_provinsi ?? ""}`
                          : (row?.nama_kabupaten ?? "-")}
                      </td>
                      <td>
                        {laporanType === "Kelambu Massal Total"
                          ? (row?.sum_kelambu_massal_hasil_desk ?? 0)
                          : (row?.sum_kelambu_fokus_hasil_desk ?? 0)}
                      </td>
                      <td>{row?.sum_total_kelambu_diterima ?? 0}</td>
                      <td>{row?.sum_total_kelambu_distribusi_desa ?? 0}</td>
                      <td>
                        {row?.sum_total_kelambu_terdistribusi_kepada_ibu_hamil ??
                          0}
                      </td>
                      <td>{row?.persen_capaian ?? 0} %</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={9}>Tidak Ada Data</td>
                </tr>
              )}
            </tbody>
            {reportsData?.length > 0 && (
              <tfoot>
                <tr
                  style={{
                    fontWeight: "bold",
                    backgroundColor: "#43766C",
                  }}
                >
                  <td style={{ color: "#FFF" }} colSpan={3}>
                    Total
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum +
                        (parseInt(
                          laporanType === "Kelambu Massal Total"
                            ? row?.sum_kelambu_massal_hasil_desk
                            : row?.sum_kelambu_fokus_hasil_desk,
                        ) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum + (parseInt(row?.sum_total_kelambu_diterima) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum +
                        (parseInt(row?.sum_total_kelambu_distribusi_desa) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum +
                        (parseInt(
                          row?.sum_total_kelambu_terdistribusi_kepada_ibu_hamil,
                        ) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {(() => {
                      const totalDiterima = reportsData.reduce(
                        (sum, row) =>
                          sum +
                          (parseInt(row?.sum_total_kelambu_diterima) || 0),
                        0,
                      );
                      const totalDistribusi = reportsData.reduce(
                        (sum, row) =>
                          sum +
                          (parseInt(row?.sum_total_kelambu_distribusi_desa) ||
                            0),
                        0,
                      );
                      return totalDiterima > 0
                        ? `${((totalDistribusi / totalDiterima) * 100).toFixed(2)}%`
                        : "-";
                    })()}
                  </td>
                </tr>
              </tfoot>
            )}
          </>
        );
      }
    }
  };

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tbody>
          <tr style={{ border: "none", padding: 0 }}>
            <th style={{ border: "none", padding: 0 }}>
              <h3>
                SISMAL v4,{" "}
                {laporanType === "Kelambu Massal Total"
                  ? "Kelambu Massal"
                  : laporanType}{" "}
                {reportInfo?.periode}
              </h3>
            </th>
          </tr>
        </tbody>
      </table>

      <table>
        <tbody>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", padding: 0 }}>Level</th>
            <th style={{ border: "none", padding: 0 }}>: {levelName}</th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", padding: 0 }}>Provinsi</th>
            <th style={{ border: "none", padding: 0 }}>
              {" "}
              :{" "}
              {reportInfo?.province
                ? reportInfo.province.split("|")[1]
                : "Semua Provinsi"}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", padding: 0 }}>Kab/Kota</th>
            <th style={{ border: "none", padding: 0 }}>
              {" "}
              :{" "}
              {reportInfo?.district
                ? reportInfo.district.split("|")[1]
                : "Semua Kab/Kota"}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", padding: 0 }}>Fasyankes</th>
            <th style={{ border: "none", padding: 0 }}>
              : {reportInfo?.fasyankes ? faskesName : "Semua Fasyankes"}
            </th>
          </tr>
        </tbody>
      </table>

      <table>{renderTableByLevel()}</table>
    </div>
  );
}
